import React from 'react';
import ConditionPage from '../components/ConditionPage';

const Cardiovascular: React.FC = () => (
  <ConditionPage
    eyebrow="Heart health"
    docTitle="Heart health — Haven Crest Health"
    title={<>Your cardiology file, <em>finally together.</em></>}
    lede="Heart care means cardiology notes, cath and echo reports, and hospital records that rarely live in one place. Haven Crest requests them for you with one click, delivers them to your own inbox, and helps you understand them and find the right cardiologist. Free, and entirely your choice."
    items={[
      { icon: '📈', title: 'Echo, stress, and cath reports', text: 'The studies that define your care, requested from the lab that ran them and delivered with a readable summary.' },
      { icon: '🏥', title: 'Hospital admissions', text: 'Discharge summaries and procedure notes from any hospital stay, in one folder.' },
      { icon: '💊', title: 'Medication history', text: 'What was prescribed, changed, or stopped, and when, so nothing gets lost between doctors.' },
      { icon: '↔', title: 'A second cardiologist', text: 'When you want another view, a navigator helps you find one and gets your records there first.' },
    ]}
  />
);

export default Cardiovascular;
